import script from "./StudentSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentSchedule.vue?vue&type=script&setup=true&lang=js"

import "./StudentSchedule.vue?vue&type=style&index=0&id=56d6371e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d6371e"]])

export default __exports__